var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrowSmSafe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33301 0.304688L12.333 10.697H0.333008L6.33301 0.304688Z",
    fill: "#86BC25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowSmSafe);
export default __webpack_public_path__ + "static/media/up-arrow-sm-safe.06bfa8b97c2077cc6aef5d639fa45c94.svg";
export { ForwardRef as ReactComponent };